import { useState } from 'react';
import { shareResult } from '../../game/share';

interface EndOfDayModalProps {
  shareText: string;
  onClose: () => void;
  isGuest: boolean;
}

/** Share sheet shown once a difficulty's day is decided (spec 10.3). */
export function EndOfDayModal({ shareText, onClose, isGuest }: EndOfDayModalProps) {
  const [copied, setCopied] = useState(false);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Today's result"
      className="fixed inset-0 z-50 flex items-end justify-center bg-black/40 p-4 sm:items-center"
    >
      <div className="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl">
        <h2 className="text-center text-lg font-bold">Today's result</h2>
        <pre
          data-testid="share-card"
          className="mt-4 whitespace-pre-wrap rounded-lg bg-stone-100 p-3 text-center font-sans text-sm text-stone-800"
        >
          {shareText}
        </pre>
        <button
          type="button"
          onClick={async () => {
            const how = await shareResult(shareText);
            if (how === 'copied') setCopied(true);
          }}
          className="mt-4 w-full rounded-md bg-emerald-700 px-4 py-2.5 font-medium text-white hover:bg-emerald-800"
        >
          {copied ? 'Copied!' : 'Copy to clipboard'}
        </button>
        {isGuest ? (
          <p className="mt-3 text-center text-sm text-emerald-900">
            You completed today's challenge —{' '}
            <a href="/login" className="font-semibold underline">
              sign in
            </a>{' '}
            to save your streak and history — and see the best possible play.
          </p>
        ) : null}
        <button
          type="button"
          onClick={onClose}
          className="mt-3 w-full rounded-md border border-stone-300 px-4 py-2 text-sm font-medium text-stone-600 hover:bg-stone-50"
        >
          Close
        </button>
      </div>
    </div>
  );
}
